import React, { useState, useEffect } from "react";

import InputRow from "Components/Molecules/InputRow/inputRow";
import LabelQuill from "Components/Molecules/LabelQuill/labelQuill";
import InputRowRadio from "Components/Molecules/InputRowRadio/inputRowRadio";
import Button from "Components/Atoms/Button/button";
import InputRowSelect from "Components/Molecules/InputRowSelect/inputRowSelect";
import InputText from "Components/Molecules/InputText/inputText";

import { useDispatch, useSelector } from "react-redux";

import { ReducerType } from "Store/store";

import useServiceNo from "Util/Hooks/useServiceIdx";

import { ADDBanner, RadioForm } from "types/interface";
import InputRowFile from "Components/Molecules/InputRowFile/inputRowFile";
import LANG, { getLang } from "Util/lang";
import {
  deleteAutoMailApi,
  getDetailAutoMailApi,
  getServiceIdDetailApi,
  postEmailBannerApi,
  putAutoMailApi,
} from "Apis/apis";
import { useLocation, useNavigate } from "react-router-dom";
import Space from "Components/Atoms/Space/space";
import { modalToggle } from "Store/Slices/modal";
import PreviewAutoMailModal from "Components/Molecules/PreviewModal/previewAutoMailModal";
import InputRowImg from "Components/Molecules/InputRowImg/inputRowImg";
import ExampleAutoMailModal from "Components/Molecules/PreviewModal/ExampleAutoMailModal";
import InputRowBannerButton from "Components/Molecules/InputRowBannerButton/inputRowBannerButton";
import AddBannerModal from "Components/Molecules/AddBannerModal/addBannerModal";

const RADIO_TYPE: RadioForm[] = [
  {
    idx: 1,
    label: "OFF",
    id: "off",
  },
  {
    idx: 0,
    label: "ON",
    id: "on",
  },
];

const AutoAnswerFix = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const serviceList = useSelector((state: ReducerType) =>
    state.serviceList.filter((el) => el.state !== 2 && el.state !== 1),
  );
  const [serviceNo, setServiceNo] = useServiceNo();
  const [supportMail, setSupportMail] = useState("");
  const [bannerFile, setBannerFile] = useState<File>({} as File);
  const [originName, setOriginName] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [footer, setFooter] = useState("");
  const [state, setState] = useState(1);
  const [imgUrl, setImgUrl] = useState("");

  const [addFile1, setAddFile1] = useState<File>({} as File);
  const [addOrigin1, setOrigin1] = useState("");
  const [addLink1, setAddLink1] = useState("");
  const [addName1, setAddName1] = useState("");
  const [addImgUrl1, setAddImgUrl1] = useState("");
  const [addMailNo1, setAddMailNo1] = useState(0);
  const [addFile2, setAddFile2] = useState<File>({} as File);
  const [addOrigin2, setOrigin2] = useState("");
  const [addLink2, setAddLink2] = useState("");
  const [addName2, setAddName2] = useState("");
  const [addImgUrl2, setAddImgUrl2] = useState("");
  const [addMailNo2, setAddMailNo2] = useState(0);
  const [addFile3, setAddFile3] = useState<File>({} as File);
  const [addOrigin3, setOrigin3] = useState("");
  const [addLink3, setAddLink3] = useState("");
  const [addName3, setAddName3] = useState("");
  const [addImgUrl3, setAddImgUrl3] = useState("");
  const [addMailNo3, setAddMailNo3] = useState(0);
  const [bannerList, setBannerList] = useState<ADDBanner[]>([]);

  const fileInputs = [
    {
      type: 0,
      ad_name: addName1,
      url: addLink1,
      order: 1,
      mail_no: addMailNo1,
      madbanner: addFile1,
    },
    {
      type: 0,
      ad_name: addName2,
      url: addLink2,
      order: 2,
      mail_no: addMailNo2,
      madbanner: addFile2,
    },
    {
      type: 0,
      ad_name: addName3,
      url: addLink3,
      order: 3,
      mail_no: addMailNo3,
      madbanner: addFile3,
    },
  ];

  const getHelpMail = async () => {
    const {
      data: {
        service: { support_mail },
      },
    } = await getServiceIdDetailApi(serviceNo);

    setSupportMail(support_mail);
  };

  const getDetailMail = async () => {
    const {
      data: { autoMail },
    } = await getDetailAutoMailApi(location.state || "");
    setServiceNo(autoMail.service_no);
    setOriginName(autoMail.original_filename);
    setImgUrl(autoMail.receive_banner);
    setTitle(autoMail.title);
    setContent(autoMail.contents);
    setFooter(autoMail.footer);
    setState(autoMail.state);
    setOrigin1(autoMail.ad_banner[0].originFilename);
    setAddLink1(autoMail.ad_banner[0].url);
    setAddName1(autoMail.ad_banner[0].ad_name);
    setAddImgUrl1(autoMail.ad_banner[0].banner_image);
    setAddMailNo1(autoMail.ad_banner[0].mail_ad_no);
    setOrigin2(autoMail.ad_banner[1].originFilename);
    setAddLink2(autoMail.ad_banner[1].url);
    setAddName2(autoMail.ad_banner[1].ad_name);
    setAddImgUrl2(autoMail.ad_banner[1].banner_image);
    setAddMailNo2(autoMail.ad_banner[1].mail_ad_no);
    setOrigin3(autoMail.ad_banner[2].originFilename);
    setAddLink3(autoMail.ad_banner[2].url);
    setAddName3(autoMail.ad_banner[2].ad_name);
    setAddImgUrl3(autoMail.ad_banner[2].banner_image);
    setAddMailNo3(autoMail.ad_banner[2].mail_ad_no);
    setBannerList(autoMail.ad_banner);
  };
  const pass = (): boolean => {
    if (serviceNo === -1) {
      alert("서비스를 선택해주세요.");
      return false;
    } else if (title === "") {
      alert("제목을 입력해주세요.");
      return false;
    } else if (content === "<p><br></p>") {
      alert("내용을 입력해주세요.");
      return false;
    } else if (footer === "<p><br></p>") {
      alert("푸터를 입력해주세요.");
      return false;
    }
    return true;
  };

  const putAutoMail = async () => {
    const isPass: boolean = pass();
    if (!isPass) return;

    const formData: any = new FormData();
    formData.append("serviceNo", serviceNo);
    formData.append("title", title);
    formData.append("contents", content);
    formData.append("footer", footer);
    formData.append("state", state);
    formData.append("receive", bannerFile);
    await putAutoMailApi(formData, location.state || "");

    for (let i = 0; i < fileInputs.length; i++) {
      const { type, ad_name, url, order, madbanner, mail_no } = fileInputs[i];
      if (ad_name === "" && url === "") continue;
      if (ad_name !== "" && url !== "" && mail_no !== -1) continue;

      const bannerData: any = new FormData();
      bannerData.append("loadNo", location.state);
      bannerData.append("type", type);
      bannerData.append("order", order);
      bannerData.append("adName", ad_name);
      bannerData.append("url", url);
      bannerData.append("madbanner", madbanner);
      await postEmailBannerApi(bannerData);
    }

    alert("자동답변이 수정되었습니다.");
    navigate("/user/maildesign", { state: { page: 1, serviceNo: serviceNo } });
  };

  const deleteAutoMail = async () => {
    await deleteAutoMailApi(location.state || "");
    alert("자동답변이 삭제되었습니다.");
    navigate("/user/maildesign", { state: { page: 1, serviceNo: serviceNo } });
  };

  useEffect(() => {
    getDetailMail();
  }, []);
  useEffect(() => {
    getHelpMail();
  }, [serviceNo]);

  return (
    <>
      <div id="autoAdd">
        <InputRowSelect
          dataList={serviceList}
          id="service"
          name="분류"
          setValue={setServiceNo}
          value={serviceNo}
        />
        <InputText name="발신메일" text={supportMail} />
        <InputRowImg
          id="banner_img"
          name="브랜드 배너"
          setValue={setBannerFile}
          imgUrl={imgUrl}
          setImgUrl={setImgUrl}
          originName={originName || ""}
          placeholder="450 x 100 사이즈 권장"
          noImg="450x100"
          height="h-100"
        />
        <InputRow
          id="title"
          name={LANG[getLang()].title}
          setValue={setTitle}
          value={title}
        />
        <LabelQuill
          id="content"
          name={LANG[getLang()].content}
          setText={setContent}
          text={content}
        />
        <LabelQuill
          id="footer"
          name="푸터"
          setText={setFooter}
          text={footer}
          placeHolder="Footer(하단바) 텍스트는 메일 하단에 표시되는 텍스트 정보입니다. 
주소, 대표 전화, 대표 이메일 등 기업의 주요 정보 및 공지사항을 Footer에 입력해보세요.
"
        />
        {/* 배너광고 시작할때 사용 */}
        <InputRowBannerButton
          id="banner"
          name="배너 광고"
          Buttonidx={3}
          data={fileInputs}
        />
        <div className="relative">
          <InputText name="미리보기" text="" />
          <div className="absolute flex top-13 left-143">
            <Button
              btnText="미리보기"
              size="md"
              onClick={() => dispatch(modalToggle(4))}
            />
            <Space x={20} />
            <Button
              onClick={() => dispatch(modalToggle(5))}
              btnText="작성예시"
              size="md"
            />
          </div>
        </div>
        <InputRowRadio
          data={RADIO_TYPE}
          name={LANG[getLang()].state}
          value={state}
          setValue={setState}
        />
        ON으로 설정하면 고객 문의과 접수됨과 동시에 문의 접수 자동 답변이
        발송됩니다.
        <div className="flex justify-end gap-10 mt-10 ">
          <Button btnText={LANG[getLang()].change} onClick={putAutoMail} />
          <Button
            btnText={LANG[getLang()].list}
            onClick={() =>
              navigate("/user/maildesign", {
                state: { page: 1, serviceNo: serviceNo },
              })
            }
          />
          <Button
            btnText={LANG[getLang()].delete}
            onClick={deleteAutoMail}
            color="delete"
          />
        </div>
      </div>
      <AddBannerModal
        modalNum={1}
        setFile={setAddFile1}
        setLink={setAddLink1}
        link={addLink1}
        addName={addName1}
        setAddName={setAddName1}
        serviceNo={serviceNo}
        imgName={addOrigin1}
        mail_ad_no={bannerList[0]?.mail_ad_no || -1}
        setImgName={setOrigin1}
        file={addFile1}
        setImgUrl={setAddImgUrl1}
        setAddMailNo={setAddMailNo1}
      />
      <AddBannerModal
        modalNum={2}
        setFile={setAddFile2}
        setLink={setAddLink2}
        link={addLink2}
        addName={addName2}
        setAddName={setAddName2}
        serviceNo={serviceNo}
        imgName={addOrigin2}
        mail_ad_no={bannerList[1]?.mail_ad_no || -1}
        setImgName={setOrigin2}
        file={addFile2}
        setImgUrl={setAddImgUrl2}
        setAddMailNo={setAddMailNo2}
      />
      <AddBannerModal
        modalNum={3}
        setFile={setAddFile3}
        setLink={setAddLink3}
        link={addLink3}
        addName={addName3}
        setAddName={setAddName3}
        serviceNo={serviceNo}
        imgName={addOrigin3}
        mail_ad_no={bannerList[2]?.mail_ad_no || -1}
        setImgName={setOrigin3}
        file={addFile3}
        setImgUrl={setAddImgUrl3}
        setAddMailNo={setAddMailNo3}
      />
      <PreviewAutoMailModal
        modalNum={4}
        title={title}
        imgUrl={imgUrl}
        content={content}
        footer={footer}
        addImgUrl1={addImgUrl1}
        addImgUrl2={addImgUrl2}
        addImgUrl3={addImgUrl3}
        url1={addLink1}
        url2={addLink2}
        url3={addLink3}
      />
      <ExampleAutoMailModal modalNum={5} />
    </>
  );
};

export default AutoAnswerFix;
